// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IkHGA","title":"styles_title__XQsjN","wrapper":"styles_wrapper__9e5Jq","item":"styles_item__ayRzu","icon":"styles_icon__snZmB"};